import { render, staticRenderFns } from "./MisPromoRequestComponent.vue?vue&type=template&id=27c2420a"
import script from "./MisPromoRequestComponent.vue?vue&type=script&lang=js"
export * from "./MisPromoRequestComponent.vue?vue&type=script&lang=js"
import style0 from "./MisPromoRequestComponent.vue?vue&type=style&index=0&id=27c2420a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports